export default "__VITE_ASSET__BfSDc3ZH__"